import { Label } from './label';

export class SystemLabel extends Label {}
